import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LabeledValueInlineContainerComponent } from '@client-ui/components/labeled-value-inline-container/labeled-value-inline-container.component';
import { environment } from '@environments/environment';
import { DetailHeaderComponent } from '@shared/components/detail-header/detail-header.component';
import { CookieConsentService } from '@shared/services/cookie-consent.service';
import { ToggleSwitch } from 'primeng/toggleswitch';

@Component({
  selector: 'cp-cookie-policy',
  imports: [LabeledValueInlineContainerComponent, DetailHeaderComponent, ToggleSwitch, FormsModule, ReactiveFormsModule],
  templateUrl: './cookie-policy.component.html',
  styleUrl: './cookie-policy.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiePolicyComponent implements OnInit {
  private readonly cookieConsentService = inject(CookieConsentService);
  private readonly destroyRef = inject(DestroyRef);

  protected analyticsCookieForm = new FormControl<boolean>(false);

  ngOnInit(): void {
    if (environment.mobileApp?.isMobileApp) return;

    this.analyticsCookieForm.setValue(this.cookieConsentService.getCookieConsent());

    this.analyticsCookieForm.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.cookieConsentService.setCookieConsent(value);
      if (value) {
        this.cookieConsentService.loadAnalytics();
      } else {
        this.cookieConsentService.deleteAllCookies();
      }
    });
  }
}
